import { render } from "./specs.vue?vue&type=template&id=82daab58&scoped=true"
import script from "./specs.vue?vue&type=script&lang=js"
export * from "./specs.vue?vue&type=script&lang=js"

import "./specs.vue?vue&type=style&index=0&id=82daab58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-82daab58"

export default script